import { render, staticRenderFns } from "./Graficos.vue?vue&type=template&id=6005234e&scoped=true&"
import script from "./Graficos.vue?vue&type=script&lang=js&"
export * from "./Graficos.vue?vue&type=script&lang=js&"
import style0 from "./Graficos.vue?vue&type=style&index=0&id=6005234e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005234e",
  null
  
)

export default component.exports